import RegimenesApi from '../../apis/Regimenes'

export default {
    namespaced: true,
    state: {
        regimenes: [],
        regimenesActivo: []
    },
    mutations: {
        set_regimenes (state, regimenes) {
            state.regimenes = regimenes
        },
        set_regimenesActivos (state, regimenesActivo) {
            state.regimenesActivo = regimenesActivo
        }
    },
    actions: {
        async getRegimenes({commit, dispatch}, filters) {
            return await RegimenesApi.get_all(filters)
                            .then( response => {
                                commit('set_regimenes', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async store({dispatch}, regimen) {
            return await RegimenesApi.store(regimen)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getRegimenes')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async update({dispatch}, regimen) {
            return await RegimenesApi.update(regimen)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true})
                                dispatch('getRegimenes')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async change_status({dispatch}, regimen) {
            let action = (regimen.activo) ? 'inactivación' : 'activación'
            return await RegimenesApi.change_status(regimen)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La '+ action + ' se relizó de forma correcta.'
                                }, {root: true})
                                dispatch('getRegimenes')
                            })
                            .catch(error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async delete({dispatch}, regimen) {
            return await RegimenesApi.delete(regimen)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root: true})
                                dispatch('getRegimenes')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true})
                            })
        },
        async regimenesActivos({commit, dispatch}) {
            return await RegimenesApi.listarActivos()
                            .then( response => {
                                commit('set_regimenesActivos', response.data)
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                }, {root: true});
                            })
        }
    }
}